import en from './en';
import pt from './pt';
import es from './es';

export const languages = {
  en,
  pt,
  es,
};

// Função para obter o idioma do navegador
export const getBrowserLanguage = () => {
  const language = navigator.language.split('-')[0];
  return languages[language] ? language : 'en';
};

// Função para obter o idioma salvo
export const getSavedLanguage = () => {
  return localStorage.getItem('language') || getBrowserLanguage();
};

// Função para salvar o idioma escolhido
export const saveLanguage = (language) => {
  localStorage.setItem('language', language);
};

// Função para obter as traduções do idioma atual
export const getTranslations = (language) => {
  return languages[language] || languages.en;
};

// Função para obter as categorias traduzidas
export const getTranslatedCategories = (categories, language) => {
  if (!categories || !categories.translations || !categories.translations[language]) {
    return {
      businessSectors: {},
      characteristics: {}
    };
  }

  return {
    businessSectors: categories.translations[language].ramoDeAtividade || {},
    characteristics: categories.translations[language].caracteristicas || {}
  };
}; 